export const states = require('../constants/states.json')

export const getStatesOptions = (t) =>
  Object.keys(states).map((code) => {
    return { label: `${code} - ${t(states[code])}`, value: code }
  })
